export class OcrRequest
{
    public userId: string;
    public images: string[];
}

export class OcrResponse
{
    public listUrlImage: OcrImageResponse[];
    public idInvoiceHeader: string;
    public dataExtractOcr: DataExtractOcr;
    public invoiceStatus: string;
    public listError: OcrError[];
    public totalTargetAmount: number;
    public totalTargetQuantity: number;
    public mechanicValid: boolean;
    public status: boolean;
    public listProductOCR: ProductOCR[];
}

export class OcrImageResponse
{
    public linkImage: string;
    public indexImage: number;
    public imageHeight: number;
    public imageWidth: number;
}

export class Coordinates
{
    public boundingBox: number[];
    public field: string;
    public imageIndex: number;
}

export class ReceiptItem
{
    public coordinates: Coordinates[];
    public name: string;
    public quantity: string;
    public total: string;
    public unitPrice: string;
    public targetProduct: boolean;
}

export class ReceiptData
{
    public items: ReceiptItem[];
    public mallName: string;
    public numberOfItems: number;
    public receiptId: string;
    public seller: string;
    public storeName: string;
    public totalAmount: number;
    public transactionDateTime: string;
}

export class InvoiceDetail
{
    public invoiceId: string;
    public issueDate: string;
    public issueDateObj: Date;
    public mallName: string;
    public storeName: string;
    public items: ReceiptItem[];
    public totalAmount: number;
    public totalQuantity: number;
    public images: OcrImageResponse[];
    public listProductOCR: ProductOCR[];
}
export class ProductOCR
{
    public nameProduct: string;
    public quantityProduct: string;
    public amountProduct: string;
    public unitPrice: string;
    public isProductU: boolean;
}

export class DataExtractOcr
{
    public receiptData: ReceiptData;
    public requestId: string;
    public status: string;
}

export class OcrError
{
    public message: string;
    public mechaincError: boolean;
}

export class InvoiceUpdateResponse
{

    public minPrice: number;
    public invoiceHeaderId: string;
    public listError: OcrError[];
    public mechanicOk: boolean;
    public validMechanics: ValidMechanics[];
    public loyaltyPoint : number = 0;
}

export class ValidMechanics
{
    public mechanic: string;
    public gifts: Gift[];
    public addTurn: boolean;
    public pages: string[];
    public maxGift: number;
}

export class Gift
{
    public productCode: string;
    public quantity: number;
}

export class CampaignConfig
{
    public mechanic: string[];
    public pageConfigs: PageConfig[];
    public activeOCR: boolean;
    public manualExtraSku: string[];
    public captureMaxTime: number;
    public allowUploadImage:boolean;
    public maxUploadSize: number;
    public allowSkipSms: boolean;
    public mall: number[];
    public store: string[];
    public cameraType: string;
    public purchaseConfirm: boolean;
    public inputBanker: boolean;
    public stockWithStore: boolean;
    public manualExtraSkuMaxTurn: number;
	public bankerList: string[];
    public limitProduct: string[];
    public luckyAfterGiveGift: boolean;
    public controlGiftQuantity: boolean;
    public roofPurcharseConfig: RoofPurcharseConfig;
    public sumTotalSkuBanker: boolean;
    public confirmCodeConfig: ConfirmCodeConfig;
    public directTopupConfig: DirectTopupConfig;
    public luckyTwiceFlowEnable: boolean;
    public mechanicFlow: MechanicFlow[];
    public luckyDrawType: string; 
    public randomGiftRules: randomGiftRule[];
    public minTurnInput: number; 
    public luckysku: string[];
    public disableLuckyDefaultFlow: boolean;
    public loyaltyConfig: LoyaltyConfig;
    public showSurvey: boolean;
    public topUIConfig: TopUIConfig;
    public userDefault: string;
    public posConfig : PosConfig;
    public mallNameApply : string[];
    public giveGiftConfig: GiveGiftConfig;
    public smsConfirmConfig: SMSConfirmConfig;
    public mechanicListBaseConfig: MechanicListBaseConfig;
    public showPGControlGiftInMechanicList: boolean;
    public shopperConfig: ShopperConfig;
    public luckyDrawConfig: LuckyDrawConfig;
	public physQrScanner: boolean;
    public registerFormConfig: RegisterForm;
}

export class RegisterForm
{
    public emailEnable: boolean;
    public genderEnable: boolean;
    public birthdayEnable: boolean;
}

export class LuckyDrawConfig
{
    public limitTurn: number;
    public enable: boolean;
}

export class MechanicFlow
{
    public subfix: string;
    public name: string;
    public type: string;
    public mechanicType: string;
    public loopStep: number;
    public ignoreMaxgift: boolean;
    public stepOnMaxGift: number;
}

export class SkuModel
{
    public id: string;
    public barcode: string;
    public productName: string;
    public quantity: number;
    public isBanker: boolean;
    public invoiceDetailId: string;
    public isDummy: boolean;
}

export class CampaignSkuResponse
{
    public skus: SkuModel[];
    public maxTurn: number;
}

export class CheckSkuRequest
{
    public invoiceHeaderId: string;
    public skus: SkuModel[];
    public maxTurn: number;
}

export class DirectTopupConfig
{
    public phoneEditable: boolean;
}

export class ConfirmCodeConfig
{
    public checkPhoneNum: boolean;
}

export class RoofPurcharseConfig
{
    constructor()
    {
        this.skuRequire = true;
        this.amountVisible = true;
        this.quantityVisible = true;
        this.bankerAmountVisible = true;
        this.bankerQuantityVisible = true;
        this.amountRequire = true;
        this.bankerRequire = false;
        this.amountMulti = 1000;
        this.skuVisible = true;
        this.luckyTurnPriceStep = 0;
    }
    public skuRequire: boolean;
    public quantityVisible: boolean;
    public amountVisible: boolean;
    public quantityRequire: boolean;
    public amountRequire: boolean;
    public bankerRequire: boolean;
    public bankerQuantityVisible: boolean;
    public bankerAmountVisible: boolean;
    public bankerQuantityRequire: boolean;
    public bankerAmountRequire: boolean;
    public amountMulti: number;
    public skuVisible: boolean;
    public luckyTurnInputVisible: boolean;
    public luckyTurnInputEditable: boolean;
    public luckyTurnBySku: TurnBySku[];
    public luckyTurnPriceStep: number;
    public allowCollectDataOnly: boolean;
}

export class TurnBySku
{
    public label: string;
    public productIds: string[];
    public premiumProductIds: string[];
    public priceStep: number;
    public turnStep: number;
}

export class TurnBySkuModel
{
    skuName: string;
    total: number
    turn: number;
    step: number;
    turnStep: number;
    listProdId: string[];
    listPremiumProdId: string[];
}

export class PageConfig
{
    public name: string;
    public enable: boolean;
    public required: boolean;
}

export const MechanicType = {
    ExtraGift: 'ExtraGift',
    PriceRange: 'PriceRange'
}

export class TurnUpdateReponse
{
    public maxTurn: number;
    public err: string;
}

export class randomGiftRule
{
    public randomFromTurn: number;
    public productCode: string;
    public showNoteGift: boolean;
}
export class LoyaltyConfig
{
    public campaignId: number;
    public productCode: string;
    public monthlyPointCapPerUser: number;
    public PriceStep: number[];
}

export class TopUIConfig 
{
    public showSkinCare: boolean;
    public showCity: boolean;
    public lockEditInfo: boolean;
    public userInfoAlwaysShow: boolean;
    public skipOTPVerify:  boolean;
    public qrSkipCustomerInfoSuccess:  boolean;
    public registerShowLocation:  boolean;
    public userInfoSkinCareSurvey: UserInfoSkinCareSurvey;
    public userInfoHideField: UserInfoHideField;
    public homeHideMallStore: boolean;
    public showSurvey: boolean;
    public useQrFlow: boolean;
    
}

export class GiveGiftConfig {
    filterGift: FilterGift;
}

export class SMSConfirmConfig {
    hideCancelButton: boolean;
}

export class MechanicListBaseConfig {
    filterMechanic: FilterMechanic;
}

export class FilterGift {
    byAnswer: FilterByAnswerItem[];
    byStore: FilterByStoreItem[];
}

export class FilterByAnswerItem {
    answerId: string;
    productCode: string[];
}

export class FilterByStoreItem {
    storeIds: string[];
    productCodes: string[];
    mechanicCodes: string[];
}

export class FilterMechanic {
    byStore: FilterByStoreItem[];
}

export class PosConfig {
    maxEditTimes: number | null;
    checkBillDate: boolean | null;
    mechanicConfigs: PosMechanicConfig[];
}

export class PosMechanicConfig {
    mechanicName: string;
    productCodes: string[];
    sumMaxGift: number | null;
}

export class UserInfoSkinCareSurvey {
    articleId: number;
    defaultCampaignId: number;
}

export class UserInfoHideField {
    email: boolean | null;
    ageRange: boolean | null;
    gender: boolean | null;
    birthday: boolean | null;
    birthdayRequire:boolean | null;
    genderRequire:boolean | null;
}


export class ShopperConfig
{
    otpRequire: boolean | true;
}
